import { render, staticRenderFns } from "./registerScreenMobile.vue?vue&type=template&id=2113f10f"
import script from "./registerScreenMobile.vue?vue&type=script&lang=js"
export * from "./registerScreenMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports